// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__XMXzR","spin":"Loader_spin__Gfb8_"};